import { formatDate } from '@utils';
import { NO_DATA_DASH } from '@src/GlobalConstants';

const transformAdministrators = ({ results = [], count }) => ({
  results: results.map((admin) => {
    const findTelecomRecord = (system) => admin?.telecom?.find((tel) => tel.system === system);
    const emailRecord = findTelecomRecord('email')?.value;
    return {
      id: admin?.id,
      firstName: admin?.name?.[0]?.given?.[0],
      lastName: admin?.name?.[0]?.family,
      email: emailRecord,
      createdOn: admin?.createdAt ? formatDate(admin?.createdAt) : NO_DATA_DASH,
    };
  }),
  count,
});

export default transformAdministrators;
